<template>
  <upload-material 
    @uploadFile="uploadMultiPage" 
    :loading="loading"
    :disabled="disabled">
  </upload-material>
</template>

<script>
import UploadMaterial from './upload-material.vue';
import utils from '@/libs/utils';
import Http from '@/libs/http';
import uploadFileService from '@/services/upload-file-service';


export default {
  components: {
    UploadMaterial,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    materialList: {
      type: Array,
      default: () => [],
    },
    maxLength: {
      type: Number,
    },
    // 判断是否为第一次新增的情况，如果是则不走请求，点击提交时候直接上传
    firstUpload: {
      type: Boolean,
      default: true,
    },
    // 当前编辑图片的申请人id
    applicantId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // 上传函数
    getUploadMultiParams(files) {
      // 在这里可以根据url判断是不是文件替换
      const promiseStack = files.map(file => uploadFileService.uploadFileWithOssout(file, false, { noKey: true }).then((res) => {
        
        const url = `https://${res.oss_out}/${res.key}`;

        // 第一次请求前端处理 
        if (this.firstUpload) { 
          const imgItem = {
            url,
            key: res.key,
            id: new Date().getTime() + Math.floor(Math.random() * 10000), // 自行模拟id
          };
          return Promise.resolve(imgItem);
        } 

        // 非第一次上传需要发送请求
        const params = {
          key: res.key,
          applicant_id: this.applicantId || undefined,
        };
        return Http.post('/reject_product_applicant_file_add', params).then(res => ({ 
          url,
          id: res.file_id || 0,
        }));
        

      }).catch((e) => {
        if (e) console.log(e);
      }));

      return Promise.all(promiseStack);
    },

    // 上传资料
    async uploadMultiPage(files) {
      this.loading = true;

      // 要判断多选的情况
      if (this.maxLength) {
        const isExceedMaxLength = this.materialList.length + files.length > this.maxLength;
        if (isExceedMaxLength) {
          utils.msg.error(`最多上传${this.maxLength}个文件`);
          return;
        }
      }

      console.log('文件上传内容为', files);
      
      // 图片上传
      this.getUploadMultiParams(files).then((imgUrlList) => {
        console.log('新增文件处理的数据为=======', imgUrlList);
        // // 查询所有空的内容进行替换
        const uploadImgList = imgUrlList.map((img, imgIndex) => {
          const dowloadName = files[imgIndex] && files[imgIndex].name;
          img.filename = dowloadName;
          return img;
        });
        this.$emit('addNewItemList', uploadImgList);
      }).catch((e) => {
        if (e) console.log(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    
  },
};
</script>


<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/orders/reject-product-applicant/components/upload-reject-material-list/components/add-upload-material.vue